import { HttpError } from '../error.js'

const TimeoutAbort = Symbol('timeout abort')

export function timeout(request, next) {
    if (!request.timeout || request.timeout <= 0) {
        return next(request)
    }

    const abortController = new AbortController()

    const signal = abortController.signal

    if (request.signal) {
        request.signal.addEventListener('abort', () => {
            abortController.abort(request.signal?.reason)
        })
    }

    const timer = setTimeout(() => {
        abortController.abort(TimeoutAbort)
        signal.reason ??= TimeoutAbort
    }, request.timeout)

    const message = request.timeoutMessage ?? '网络请求超时！'
    const messageFunction = typeof message === 'function' ? message : () => message

    return next({
        ...request,
        signal,
    }).then(
        (resp) => (clearTimeout(timer), resp),
        (error) => {
            if (error instanceof Error && error?.name === 'AbortError' && signal.reason === TimeoutAbort) {
                throw new HttpError({
                    code: 408,
                    status: false,
                    message: messageFunction(),
                })
            }
            throw error
        },
    )
}
